import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onChange", "size", "value", "variant"],
  _excluded2 = ["children", "value"];
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { useContext } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { createContext } from 'react';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SegmentedButtonContext = /*#__PURE__*/createContext(undefined);
export function SegmentedButton(_ref) {
  let {
      children,
      onChange,
      size = 'xs',
      value,
      variant
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(SegmentedButtonContext.Provider, {
    value: {
      onChange,
      size,
      value,
      variant
    },
    children: /*#__PURE__*/_jsx(ButtonGroup, Object.assign({}, spacingProps, rest, {
      children: children
    }))
  });
}
export const useSegmentedButton = () => {
  const context = useContext(SegmentedButtonContext);
  if (!context) {
    throw new Error('useSegmentedButton must be used within a SegmentedButton');
  }
  return context;
};
const SegmentedButtonButton = _ref2 => {
  let {
      children,
      value
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    onChange,
    size,
    value: selectedValue,
    variant
  } = useSegmentedButton();
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    active: selectedValue === value,
    onClick: () => onChange(value),
    size: size,
    use: variant,
    children: children
  }));
};
SegmentedButton.Button = SegmentedButtonButton;